export default "<body-overlay class=\"body-overlay\"></body-overlay>";